/**
 * The contact page's cards a link can land on (`?card=<id>`, read by CustomerContactMainView): each card's DOM id. The
 * Activity page's rows link to the card their event is about (convex/lib/eventLink.ts), so a card listed here carries
 * this id on its root. The `rw-sec-*` ids are the Disputes round workspace's own sub-sections.
 */
export const CONTACT_CARD_IDS = [
    "profile", "credit-protection", "monitoring",
    "rounds", "latest-report",
    "tradelines-table",
    "credit-study", "dispute-outcomes",
    "rw-sec-rounds", "rw-sec-letters",
    "payment-methods", "memberships",
] as const;
export type ContactCardId = (typeof CONTACT_CARD_IDS)[number];

/** The query parameter a link names its card in. */
export const CONTACT_CARD_PARAM = "card";
/** The query parameter a link names its rail Overview row in. */
export const CONTACT_RAIL_PARAM = "rail";

export function isContactCardId(value: string): value is ContactCardId {
    return CONTACT_CARD_IDS.some((id) => id === value);
}
